<template>
  <!-- Main Sidebar Container -->
  <aside id="sideBar" class="main-sidebar sidebar-dark-primary elevation-4">
    <!-- Brand Logo -->
    <router-link to="/admin/dashboard" id="brandLink" class="brand-link">
      <!-- <img src="dist/img/AdminLTELogo.png" alt="AdminLTE Logo" class="brand-image img-circle elevation-3"
           style="opacity: .8"> -->
      <span class="brand-text font-weight-light">پنل مدیریت</span>
    </router-link>

    <!-- Sidebar -->
    <div class="sidebar" style="direction: ltr">
      <div style="direction: rtl">
        <!-- Sidebar Menu -->
        <nav class="mt-2">
          <ul
            class="nav nav-pills nav-sidebar flex-column menu_options"
            data-widget="treeview"
            role="menu"
            data-accordion="false"
          >
            <!-- Add icons to the links using the .nav-icon class
                 with font-awesome or any other icon font library -->

            <li
              :class="{ activeRoute: $route.name == 'Payments' }"
              class="nav-item"
            >
              <router-link
                style="cursor: pointer;"
                to="/admin/publisher"
                class="nav-link activeLink"
              >
                <i class="fa fa-user navicon"></i>
                <p>مدیریت ناشرین</p>
              </router-link>
            </li>
        
            <li
              :class="{ activeRoute: $route.name == 'Payments' }"
              class="nav-item"
            >
              <router-link
                style="cursor: pointer;"
                to="/admin/author"
                class="nav-link activeLink"
              >
                <i class="fa fa-pen-nib navicon"></i>
                <p>مدیریت نویسندگان</p>
              </router-link>
            </li>
            <li
              :class="{ activeRoute: $route.name == 'Payments' }"
              class="nav-item"
            >
              <router-link
                style="cursor: pointer;"
                to="/admin/book-type"
                class="nav-link activeLink"
              >
                <i class="fa fa-book-open navicon"></i>
                <p>مدیریت نوع کتاب ها</p>
              </router-link>
            </li>
            <li
              :class="{ activeRoute: $route.name == 'Payments' }"
              class="nav-item"
            >
              <router-link
                style="cursor: pointer;"
                to="/admin/book-specification"
                class="nav-link activeLink"
              >
                <i class="fa fa-book-reader navicon"></i>
                <p>مشخصات آثار</p>
              </router-link>
            </li>
            <li
              :class="{ activeRoute: $route.name == 'Payments' }"
              class="nav-item"
            >
              <router-link
                style="cursor: pointer;"
                to="/admin/book-category"
                class="nav-link activeLink"
              >
                <i class="fa fa-align-center navicon"></i>
                <p>رده بندی آثار</p>
              </router-link>
            </li>
            <li
              :class="{ activeRoute: $route.name == 'Payments' }"
              class="nav-item"
            >
              <router-link
                style="cursor: pointer;"
                to="/admin/books"
                class="nav-link activeLink"
              >
                <i class="fa fa-book navicon"></i>
                <p>مدیریت کتاب ها</p>
              </router-link>
            </li>
            <li
              :class="{ activeRoute: $route.name == 'getBook' }"
              class="nav-item"
            >
              <router-link
                style="cursor: pointer;"
                to="/admin/getBook"
                class="nav-link activeLink"
              >
                <i class="fa fa-book navicon"></i>
                <p>دریافت کتاب</p>
              </router-link>
            </li>
            <li
              :class="{ activeRoute: $route.name == 'Payments' }"
              class="nav-item"
            >
              <router-link
                style="cursor: pointer;"
                to="/admin/comments"
                class="nav-link activeLink"
              >
                <i class="fa fa-comments navicon"></i>
                <p>مدیریت نظرات</p>
              </router-link>
            </li>
            <li
              :class="{ activeRoute: $route.name == 'Payments' }"
              class="nav-item"
            >
              <router-link
                style="cursor: pointer;"
                to="/admin/slider"
                class="nav-link activeLink"
              >
                <i class="fa fa-sliders-h navicon"></i>
                <p>مدیریت اسلایدر کتاب ها</p>
              </router-link>
            </li>
            <li
              :class="{ activeRoute: $route.name == 'Payments' }"
              class="nav-item"
            >
              <router-link
                style="cursor: pointer;"
                to="/admin/pages"
                class="nav-link activeLink"
              >
                <i class="fa fa-pager navicon"></i>
                <p>مدیریت صفحات</p>
              </router-link>
            </li>
            <li
              :class="{ activeRoute: $route.name == 'Payments' }"
              class="nav-item"
            >
              <router-link
                style="cursor: pointer;"
                to="/admin/menus"
                class="nav-link activeLink"
              >
                <i class="fa fa-list-alt navicon"></i>
                <p>مدیریت منوساز</p>
              </router-link>
            </li>
            <li
              :class="{ activeRoute: $route.name == 'Payments' }"
              class="nav-item"
            >
              <router-link
                style="cursor: pointer;"
                to="/admin/settings"
                class="nav-link activeLink"
              >
                <i class="fa fa-cogs navicon"></i>
                <p>مدیریت تنظیمات</p>
              </router-link>
            </li>
            <!-- <li
            
            style="cursor: pointer;"
              @click="activeRoute = 'main_info'"
              class="nav-item has-treeview"
              :class="{
                'menu-open':
                  activeRoute == 'main_info' ||
                  $route.name == 'Specification' ||
                  $route.name == 'educationDegree' ||
                  $route.name == 'Professor',
                activeRoute:
                  activeRoute == 'main_info' ||
                  $route.name == 'Specification' ||
                  $route.name == 'educationDegree' ||
                  $route.name == 'Professor'
              }"
            >
              <a class="nav-link">
                <i class="nav-icon fa fa-edit navicon"></i>
                <p>
                  اطلاعات پایه
                  <i class="right fa fa-angle-left"></i>
                </p>
              </a>
              <ul class="nav nav-treeview">
                <li
                  :class="{ activeRoute: $route.name == 'Specification' }"
                  class="nav-item"
                >
                  <router-link to="/admin/specification" class="nav-link">
                    <i class="fa fa-book navicon"></i>
                    <p>مشخصه ها</p>
                  </router-link>
                </li>
                <li
                  :class="{ activeRoute: $route.name == 'educationDegree' }"
                  class="nav-item"
                >
                  <router-link
                    to="/admin/education-degree"
                    class="nav-link activeLink"
                  >
                    <i class="fa fa-user-graduate navicon"></i>
                    <p>مدرک تحصیلی</p>
                  </router-link>
                </li>
                <li
                  :class="{ activeRoute: $route.name == 'Professor' }"
                  class="nav-item"
                >
                  <router-link to="/admin/professor" class="nav-link activeLink">
                    <i class="fa fa-user-tie navicon"></i>
                    <p>اساتید</p>
                  </router-link>
                </li>
              </ul>
            </li> -->
          </ul>
        </nav>

        <!-- /.sidebar-menu -->
      </div>
    </div>
    <!-- /.sidebar -->
  </aside>
</template>
<script>
export default {
  data() {
    return { activeRoute: null };
  },
  watch: {
    $route: {
      handler: function(val) {
        console.log(val);
      }
    }
  },
  methods: {}
};
</script>
<style scoped>
#brandLink {
  display: flex;
  justify-content: center;
}
.nav-treeview li {
  background: aqua;
}
.sidebar-dark-primary .nav-sidebar > .nav-item.menu-open > .nav-link,
.sidebar-dark-primary .nav-sidebar > .nav-item:hover > .nav-link {
  color: black;
  background-color: #f4f4f4!important;
}
.has-treeview a {
  display: flex;
  justify-content: flex-start;
  padding-right: 16px;
}
.nav .nav-treeview li a {
  display: flex;
  justify-content: flex-start;
  padding-right: 48px;
}
.navicon {
  padding-left: 10px;
}
.menu_options li {
  margin-bottom: 5px;
}
</style>
